import React, { Component } from 'react';

import API from '../../../actions/api-helper';
import UI from '../../../actions/ui-helper';

class ProntuarioDocumentos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      documento: {
        nome: ""
      }
    }

    this.arquivoChange = this.arquivoChange.bind(this);
  }

  componentDidUpdate() {
    UI.dataTable("#dt-prontuario-c");
  }

  selecionarArquivo() {
    document.getElementById('documento-file').click();
  }

  arquivoChange(event) {
    event.persist();

    let documento = {
      nome: event.target.files[0].name
    };

    let form = new FormData();
    form.append("file", event.target.files[0]);

    UI.loader('show', "Aguarde, enviando arquivo...");
    API.post("/documentos/paciente/" + this.props.paciente.id, form, true)
      .then((json) => {
        UI.alert(json.success, json.message);
        this.props.onUploaded(json.data);
        UI.loader('hide');
      });

    this.setState({ documento: documento });
  }

  download(documento, i) {
    var link = document.createElement("a");
    link.setAttribute("href", API.baseUrl + documento.download + "?accessToken=" + API.accessToken());
    link.setAttribute("download", documento.nome);
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
  }

  render() {
    let styleContraste = {
      border: "1px dashed #777",
      fontWeight: "700",
      background: "#fff"
    }

    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">DOCUMENTOS ANEXADOS</h4>
                <p className="card-description" />
                <div className="form-group">
                  <label>Nome do arquivo</label>
                  <input id="documento-file" type="file" name="file" className="file-upload-default" onChange={this.arquivoChange} />
                  <div className="input-group col-xs-12">
                    <input
                      disabled
                      style={styleContraste}
                      type="text"
                      className="form-control file-upload-info"
                      placeholder="SELECIONE UM ARQUIVO PARA ANEXAR..."
                      value={this.state.documento.nome} />
                    <span className="input-group-append">
                      <button onClick={() => this.selecionarArquivo()} className="file-upload-browse btn btn-info" type="button" >Anexar Documento</button>
                    </span>
                  </div>
                </div>
                <div className="row">
                  {this.props.documentos && this.props.documentos.length > 0 &&
                    <div className="col-12 table-responsive">
                      <table id="dt-prontuario-c" className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Data</th>
                            <th>Usuario</th>
                            <th>Nome</th>
                            <th>Opções</th>
                          </tr>
                        </thead>
                        <tbody>{
                          this.props.documentos.map((documento, i) => {
                            return (
                              <tr key={documento.id}>
                                <td>{documento.id}</td>
                                <td>{documento.dataHora}</td>
                                <td>{documento.usuarioNome}</td>
                                <td>{documento.nome}</td>
                                <td>
                                  <div className="dropdown">
                                    <button className="btn btn-xs btn-light icon-btn btn-option" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      <i className="fa fa-cog"></i>
                                    </button>
                                    <div className="dropdown-menu">
                                      <span onClick={() => this.download(documento, i)} className="dropdown-item"><i className="fa fa-download"></i>&nbsp;Download</span>
                                      <span onClick={() => this.props.onExcluir(documento, i)} className="dropdown-item"><i className="fa fa-times"></i>&nbsp;Excluir</span>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>);
  }
}

export default ProntuarioDocumentos;